import { render, staticRenderFns } from "./person_add.vue?vue&type=template&id=3e738751&"
import script from "./person_add.vue?vue&type=script&lang=js&"
export * from "./person_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e738751')) {
      api.createRecord('3e738751', component.options)
    } else {
      api.reload('3e738751', component.options)
    }
    module.hot.accept("./person_add.vue?vue&type=template&id=3e738751&", function () {
      api.rerender('3e738751', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/people/person_add.vue"
export default component.exports